import { render, staticRenderFns } from "./RefundTransaction.vue?vue&type=template&id=5c633983&scoped=true"
import script from "./RefundTransaction.vue?vue&type=script&lang=js"
export * from "./RefundTransaction.vue?vue&type=script&lang=js"
import style0 from "./RefundTransaction.vue?vue&type=style&index=0&id=5c633983&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c633983",
  null
  
)

export default component.exports